import React from "react";
import PropTypes from "prop-types";

import NumberFormat from 'react-number-format';

//
import { Card } from "react-bootstrap";

function DollarCostStatistics({ data }) {
  /**
   * Convert Data
   * for split and return splited
   */
  const convertValue = (value, sign) => {
    let str = `${value.toFixed(2)}`;
    let splited = sign === 'dollar' ? str.split(".") : [str]

    return (
      <>
        <h4>
          {sign === "dollar" && "$"}
          <NumberFormat value={splited[0]} displayType={'text'} thousandSeparator={true} decimalSeparator="." />
          {sign === 'percent' && '%'}
        </h4>
        {splited[1] && <p>.{splited[1]}</p>}
      </>
    );
  };

  return (
    <Card className="invest-info">
      <Card.Body>
        <div className="item">
          <i className="icon icon-database-slice"></i>

          <div>
            <small>Total Value</small>

            {data.value ? (
              <div className="d-flex align-items-baseline">
                {convertValue(data.value , 'dollar')}
              </div>
            ) : (
              <h4>N/A</h4>
            )}
          </div>
        </div>

        <div className="item">
          <i className="icon icon-stock-chart"></i>

          <div>
            <small>Total Invesment</small>
            {data.invest ? (
              <div className="d-flex align-items-baseline">
                {convertValue(data.invest , 'dollar')}
              </div>
            ) : (
              <h4>N/A</h4>
            )}
          </div>
        </div>

        <div className="item">
          <i className="icon icon-percent"></i>

          <div>
            <small>Percentage Change</small>
            {data.percent ? (
              <div className="d-flex align-items-baseline">
                
                {convertValue(data.percent , 'percent')}
              </div>
            ) : (
              <h4>N/A</h4>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

DollarCostStatistics.propTypes = {
  data: PropTypes.object.isRequired,
};

export default DollarCostStatistics;
